import { render, staticRenderFns } from "./ShopCategory.vue?vue&type=template&id=e63dc492&scoped=true"
import script from "./ShopCategory.vue?vue&type=script&lang=js"
export * from "./ShopCategory.vue?vue&type=script&lang=js"
import style0 from "./ShopCategory.vue?vue&type=style&index=0&id=e63dc492&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e63dc492",
  null
  
)

export default component.exports